/* eslint-disable max-lines */
import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdStylio1 } from './pages'

type TIdToPageMapStylio1 = Record<PageIdStylio1, TPageMapValue>

export const ID_TO_PAGE_MAP_STYLIO_1: TIdToPageMapStylio1 = {
  [PageIdStylio1.START_SCREEN_STYLIO_1]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_1/pages/start-screen/StartScreen').then(
        (m) => ({
          default: m.StartScreen,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_1/pages/start-screen/StartScreen'),
  },
  [PageIdStylio1.AGE_STYLIO_1]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_1/pages/questions/AgeQuestion').then(
        (m) => ({
          default: m.AgeQuestion,
        }),
      ),
    ),
    preload: () => import('nove8/cohorts/stylio_1/pages/questions/AgeQuestion'),
  },
  [PageIdStylio1.URGE_STYLIO_1]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_1/pages/urge/UrgePage').then((m) => ({
        default: m.UrgePage,
      })),
    ),
    preload: () => import('nove8/cohorts/stylio_1/pages/urge/UrgePage'),
  },
  [PageIdStylio1.HAIR_COLOR_STYLIO_1]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_1/pages/questions/HairColorQuestion').then(
        (m) => ({
          default: m.HairColorQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_1/pages/questions/HairColorQuestion'),
  },
  [PageIdStylio1.EYES_COLOR_STYLIO_1]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_1/pages/questions/EyesColorQuestion').then(
        (m) => ({
          default: m.EyesColorQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_1/pages/questions/EyesColorQuestion'),
  },
  [PageIdStylio1.JEWELRY_STYLIO_1]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_1/pages/questions/JewelryQuestion').then(
        (m) => ({
          default: m.JewelryQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_1/pages/questions/JewelryQuestion'),
  },
  [PageIdStylio1.BODY_SHAPE_STYLIO_1]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_1/pages/questions/BodyShapeQuestion').then(
        (m) => ({
          default: m.BodyShapeQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_1/pages/questions/BodyShapeQuestion'),
  },
  [PageIdStylio1.STYLIO_TO_HELP_STYLIO_1]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_1/pages/questions/StylioToHelp').then(
        (m) => ({
          default: m.StylioToHelp,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_1/pages/questions/StylioToHelp'),
  },
  [PageIdStylio1.TALL_STYLIO_1]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_1/pages/questions/TallQuestion').then(
        (m) => ({
          default: m.TallQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_1/pages/questions/TallQuestion'),
  },
  [PageIdStylio1.WEIGHT_STYLIO_1]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_1/pages/questions/WeightQuestion').then(
        (m) => ({
          default: m.WeightQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_1/pages/questions/WeightQuestion'),
  },
  [PageIdStylio1.URGE_2_STYLIO_1]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_1/pages/urge/UrgePageVariant2').then(
        (m) => ({
          default: m.UrgePageVariant2,
        }),
      ),
    ),
    preload: () => import('nove8/cohorts/stylio_1/pages/urge/UrgePageVariant2'),
  },
  [PageIdStylio1.SHOPPING_STYLIO_1]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_1/pages/questions/ShoppingQuestion').then(
        (m) => ({
          default: m.ShoppingQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_1/pages/questions/ShoppingQuestion'),
  },
  [PageIdStylio1.STYLE_MOST_MATTERS_STYLIO_1]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_1/pages/questions/StyleMostMattersQuestion'
      ).then((m) => ({
        default: m.StyleMostMattersQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_1/pages/questions/StyleMostMattersQuestion'),
  },
  [PageIdStylio1.FAVORITE_COLORS_STYLIO_1]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_1/pages/questions/FavoriteColorsQuestion'
      ).then((m) => ({
        default: m.FavoriteColorsQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_1/pages/questions/FavoriteColorsQuestion'),
  },
  [PageIdStylio1.LIKE_OR_DISLIKE_STYLIO_1]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_1/pages/likeOrDislike/LikeOrDislikeVariant1Stylio1'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant1Stylio1,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_1/pages/likeOrDislike/LikeOrDislikeVariant1Stylio1'
      ),
  },
  [PageIdStylio1.LIKE_OR_DISLIKE_11_STYLIO_1]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_1/pages/likeOrDislike/LikeOrDislikeVariant2Stylio1'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant2Stylio1,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_1/pages/likeOrDislike/LikeOrDislikeVariant2Stylio1'
      ),
  },
  [PageIdStylio1.LIKE_OR_DISLIKE_12_STYLIO_1]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_1/pages/likeOrDislike/LikeOrDislikeVariant3Stylio1'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant3Stylio1,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_1/pages/likeOrDislike/LikeOrDislikeVariant3Stylio1'
      ),
  },
  [PageIdStylio1.LIKE_OR_DISLIKE_13_STYLIO_1]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_1/pages/likeOrDislike/LikeOrDislikeVariant4Stylio1'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant4Stylio1,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_1/pages/likeOrDislike/LikeOrDislikeVariant4Stylio1'
      ),
  },
  [PageIdStylio1.LIKE_OR_DISLIKE_14_STYLIO_1]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_1/pages/likeOrDislike/LikeOrDislikeVariant5Stylio1'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant5Stylio1,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_1/pages/likeOrDislike/LikeOrDislikeVariant5Stylio1'
      ),
  },
  [PageIdStylio1.LIKE_OR_DISLIKE_15_STYLIO_1]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_1/pages/likeOrDislike/LikeOrDislikeVariant6Stylio1'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant6Stylio1,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_1/pages/likeOrDislike/LikeOrDislikeVariant6Stylio1'
      ),
  },
  [PageIdStylio1.LIKE_OR_DISLIKE_16_STYLIO_1]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_1/pages/likeOrDislike/LikeOrDislikeVariant7Stylio1'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant7Stylio1,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_1/pages/likeOrDislike/LikeOrDislikeVariant7Stylio1'
      ),
  },
  [PageIdStylio1.LIKE_OR_DISLIKE_17_STYLIO_1]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_1/pages/likeOrDislike/LikeOrDislikeVariant8Stylio1'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant8Stylio1,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_1/pages/likeOrDislike/LikeOrDislikeVariant8Stylio1'
      ),
  },
  [PageIdStylio1.STYLES_FEEL_LIKE_YOU_STYLIO_1]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_1/pages/questions/StylesFeelLikeYou').then(
        (m) => ({
          default: m.StylesFeelLikeYou,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_1/pages/questions/StylesFeelLikeYou'),
  },
  [PageIdStylio1.URGE_4_STYLIO_1]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_1/pages/urge/UrgePageVariant4').then(
        (m) => ({
          default: m.UrgePageVariant4,
        }),
      ),
    ),
    preload: () => import('nove8/cohorts/stylio_1/pages/urge/UrgePageVariant4'),
  },
  [PageIdStylio1.BRAND_STYLIO_1]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_1/pages/questions/BrandQuestion').then(
        (m) => ({
          default: m.BrandQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_1/pages/questions/BrandQuestion'),
  },
  [PageIdStylio1.FIND_NEW_CLOTHES_STYLIO_1]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_1/pages/questions/FindNewClothesQuestion'
      ).then((m) => ({
        default: m.FindNewClothesQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_1/pages/questions/FindNewClothesQuestion'),
  },
  [PageIdStylio1.NOTHING_TO_WEAR_STYLIO_1]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_1/pages/questions/NothingToWearQuestion'
      ).then((m) => ({
        default: m.NothingToWearQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_1/pages/questions/NothingToWearQuestion'),
  },
  [PageIdStylio1.OLD_CLOTHES_STYLIO_1]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_1/pages/questions/OldClothesQuestion').then(
        (m) => ({
          default: m.OldClothesQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_1/pages/questions/OldClothesQuestion'),
  },
  [PageIdStylio1.COMBINE_CLOTHES_STYLIO_1]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_1/pages/questions/CombineClothesQuestion'
      ).then((m) => ({
        default: m.CombineClothesQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_1/pages/questions/CombineClothesQuestion'),
  },
  [PageIdStylio1.OUTFIT_LOOK_STYLIO_1]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_1/pages/questions/OutfitLook').then((m) => ({
        default: m.OutfitLook,
      })),
    ),
    preload: () => import('nove8/cohorts/stylio_1/pages/questions/OutfitLook'),
  },
  [PageIdStylio1.OPTIMIZE_BUDGET_STYLIO_1]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_1/pages/questions/OptimizeBudgetQuestion'
      ).then((m) => ({
        default: m.OptimizeBudgetQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_1/pages/questions/OptimizeBudgetQuestion'),
  },
  [PageIdStylio1.EVERYDAY_LIFESTYLE_STYLIO_1]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_1/pages/questions/EverydayLifestyle').then(
        (m) => ({
          default: m.EverydayLifestyle,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_1/pages/questions/EverydayLifestyle'),
  },
  [PageIdStylio1.CLIMAT_STYLIO_1]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_1/pages/questions/ClimatQuestion').then(
        (m) => ({
          default: m.ClimatQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_1/pages/questions/ClimatQuestion'),
  },
  [PageIdStylio1.URGE_3_STYLIO_1]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_1/pages/urge/UrgePageVariant3').then(
        (m) => ({
          default: m.UrgePageVariant3,
        }),
      ),
    ),
    preload: () => import('nove8/cohorts/stylio_1/pages/urge/UrgePageVariant3'),
  },
  [PageIdStylio1.PREPARE_FLOW_STYLIO_1]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_1/pages/prepareFlow/PrepareFlow').then(
        (m) => ({
          default: m.PrepareFlow,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_1/pages/prepareFlow/PrepareFlow'),
  },
  [PageIdStylio1.EMAIL_STYLIO_1]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_1/pages/email/Email').then((m) => ({
        default: m.Email,
      })),
    ),
    preload: () => import('nove8/cohorts/stylio_1/pages/email/Email'),
  },
  [PageIdStylio1.EMAIL_CONSENT_STYLIO_1]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_1/pages/email/EmailConsent').then((m) => ({
        default: m.EmailConsent,
      })),
    ),
    preload: () => import('nove8/cohorts/stylio_1/pages/email/EmailConsent'),
  },
  [PageIdStylio1.SUBSCRIPTIONS_STYLIO_1]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_1/pages/subscriptions/SubscriptionsVariant1'
      ).then((m) => ({
        default: m.SubscriptionsVariant1,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_1/pages/subscriptions/SubscriptionsVariant1'
      ),
  },
  [PageIdStylio1.CANCEL_OFFER_STYLIO_1]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_1/pages/cancel-offer/CancelOffer').then(
        (m) => ({
          default: m.CancelOffer,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_1/pages/cancel-offer/CancelOffer'),
  },
  [PageIdStylio1.SUB_UPSELL_STYLIO_1]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_1/pages/sub-upsell/SubUpsell').then((m) => ({
        default: m.SubUpsell,
      })),
    ),
    preload: () => import('nove8/cohorts/stylio_1/pages/sub-upsell/SubUpsell'),
  },
  [PageIdStylio1.UPSELL_STYLIO_1]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_1/pages/upsell/Upsell').then((m) => ({
        default: m.Upsell,
      })),
    ),
    preload: () => import('nove8/cohorts/stylio_1/pages/upsell/Upsell'),
  },
  [PageIdStylio1.NAME_STYLIO_1]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_1/pages/email/Email').then((m) => ({
        default: m.Email,
      })),
    ),
    preload: () => import('nove8/cohorts/stylio_1/pages/email/Email'),
  },
  [PageIdStylio1.LAST_CHANCE_OFFER_STYLIO_1]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_1/pages/last-chance-offer/LastChanceOffer'
      ).then((m) => ({
        default: m.LastChanceOffer,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_1/pages/last-chance-offer/LastChanceOffer'),
  },
  [PageIdStylio1.LIKE_OR_DISLIKE_18_STYLIO_1]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_1/pages/likeOrDislike/LikeOrDislikeVariant9Stylio1'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant9Stylio1,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_1/pages/likeOrDislike/LikeOrDislikeVariant9Stylio1'
      ),
  },
  [PageIdStylio1.LIKE_OR_DISLIKE_19_STYLIO_1]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_1/pages/likeOrDislike/LikeOrDislikeVariant10Stylio1'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant10Stylio1,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_1/pages/likeOrDislike/LikeOrDislikeVariant10Stylio1'
      ),
  },
  [PageIdStylio1.DOWNLOAD_STYLIO_1]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_1/pages/download-app/DownloadDefault').then(
        (m) => ({
          default: m.DownloadDefault,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_1/pages/download-app/DownloadDefault'),
  },
}
